import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    height: 20,
    position: "relative",
    display: "flex",
    width: 35,
  },
  tgl: {
    display: "none",
    "&:checked + .tgl-btn:after": {
      insetInlineStart: "43%",
      background: theme.colors.Primary,
    },
    "&:checked + .tgl-btn": {
      background: theme.colors.Primary,
    },
  },
  genButton: {
    outline: 0,
    display: "block",
    width: 35,
    height: 14,
    margin: "3px 0",
    cursor: "pointer",
    "-webkit-user-select": "none",
    "-moz-user-select": "none",
    "-ms-user-select": "none",
    "user-select": "none",
    background: theme.colors.TextGray,
    borderRadius: "2em",
    opacity: 0.5,
    "&:before": {
      display: "none",
    },
  },
  disabled: {
    opacity: 0.5,
  },
  circle: {
    width: 20,
    height: 20,
    background: theme.colors.TextSilver,
    borderRadius: "50%",
    position: "absolute",
    insetInlineStart: 0,
    "-webkit-transition": "all .4s ease",
    transition: "all .4s ease",
    pointerEvents: "none",
  },
  checked: {
    insetInlineStart: "43%",
    background: theme.colors.Primary,
  },
}));
